import { render, staticRenderFns } from "./PreBuildingForm.vue?vue&type=template&id=44662590&"
import script from "./PreBuildingForm.vue?vue&type=script&lang=js&"
export * from "./PreBuildingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44662590')) {
      api.createRecord('44662590', component.options)
    } else {
      api.reload('44662590', component.options)
    }
    module.hot.accept("./PreBuildingForm.vue?vue&type=template&id=44662590&", function () {
      api.rerender('44662590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/basedata/modules/PreBuildingForm.vue"
export default component.exports